import { render, staticRenderFns } from "./header4.vue?vue&type=template&id=4af1154e&scoped=true"
import script from "./header4.vue?vue&type=script&lang=js"
export * from "./header4.vue?vue&type=script&lang=js"
import style0 from "./header4.vue?vue&type=style&index=0&id=4af1154e&prod&lang=less"
import style1 from "./header4.vue?vue&type=style&index=1&id=4af1154e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af1154e",
  null
  
)

export default component.exports